import { isMobile } from 'app-constants';

function vibrateDevice(pattern: number | number[]) {
    if (!isMobile) return;

    // NOTE: This does not work in safari
    if (typeof window.navigator.vibrate === 'function') {
        window.navigator.vibrate(pattern);
    }
}

export default vibrateDevice;
